export default function() {
  return [
    {
      title: "Negócios",
      htmlBefore: '<i class="fas fa-briefcase"></i>',
      items: [
        {
          title: "Dashboard de negócio",
          to: "/deals/business-dashboard",
          htmlBefore: '<i class="fas fa-chart-bar"></i>',
          controller: "InternalDashboard",
          action: "GetBusiness"
        },
        {
          title: "Dashboard de marketplace",
          to: "/deals/marketplace-dashboard",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-store-alt"></i>',
          controller: "InternalDashboard",
          action: "GetMarketplace"
        },
        {
          title: "Negociações em andamento",
          to: "/deals/prospects",
          htmlBefore: '<i class="fas fa-id-badge"></i>',
          controller: "Prospect",
          action: "List"
        },
        {
          title: "Maquininhas",
          to: "/deals/merchantmaquina",
          htmlBefore: '<i class="fas fa-id-badge"></i>',
          controller: "MerchantMaquina",
          action: "List"
        },
        {
          title: "Estoque Maquinas",
          to: "/deals/maquina",
          htmlBefore: '<i class="fas fa-id-badge"></i>',
          controller: "Maquina",
          action: "List"
        },
        {
          title: "Clientes",
          to: "/deals/clients",
          htmlBefore: '<i class="fas fa-user-check"></i>',
          controller: "Merchant",
          action: "List"
        },
        {
          title: "Pré-cadastro",
          to: "/deals/pre-clients",
          htmlBefore: '<i class="fas fa-user-lock"></i>',
          dividerEnabled: true,
          controller: "MerchantPreview",
          action: "List"
        },
        {
          title: "Parceiros",
          to: "/deals/partners",
          htmlBefore: '<i class="fas fa-handshake"></i>',
          dividerEnabled: true,
          controller: "Partner",
          action: "List"
        },
        {
          title: "Usuários dos Clientes",
          to: "/deals/clients/merchant",       
          htmlBefore: '<i class="fas fa-user"></i>',
          dividerEnabled: true,
          controller: "Merchant",            
          action: "List"
        },
        {
          title: "Resultado dos anúncios",
          to: "/deals/merchant-campaigns",
          htmlBefore: '<i class="fas fa-bullhorn"></i>',
          controller: "Campaign",
          dividerEnabled: true,
          action: "ListMerchant"
        }
      ]
    },
    {
      title: "Operacional",
      htmlBefore: '<i class="fas fa-dollar-sign"></i>',
      items: [
        {
          title: "Dashboard financeiro",
          to: "/financial/financial-dashboard",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-chart-line"></i>',
          controller: "Profit",
          action: "Get"
        },
        {
          title: "Clientes negativos",
          to: "/financial/checking-account-merchants-negative",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-search-dollar"></i>',
          controller: "CheckingAccount",
          action: "ListMerchantNegative"
        },
        {
          title: "Antecipações de pagamentos",
          to: "/financial/advance-payments",
          htmlBefore: '<i class="fas fa-money-check-alt"></i>',
          controller: "AdvancePayment",
          action: "List"
        },
        {
          title: "Borderôs",
          to: "/financial/advance-payment-operations",
          htmlBefore: '<i class="fas fa-money-check"></i>',
          controller: "AdvancePaymentOperation",
          action: "List"
        },
        {
          title: 'Pagamentos',
          to: '/financial/payments',
          htmlBefore: '<i class="fas fa-piggy-bank"></i>',
          controller: "CheckingAccount",
          action: "ListMerchant"
        },
        {
          title: 'Pagamentos Duplicados',
          to: '/financial/double-payment',
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-clone"></i>',
          controller: 'DoublePayment',
          action: 'List'
        },
        {
          title: 'Faturamento dos clientes',
          to: '/financial/profits',
          htmlBefore: '<i class="fas fa-donate"></i>',
          controller: "Profit",
          action: "ListMerchant"
        },
        {
          title: "Notas de serviço dos clientes",
          to: "/financial/note-extracts",
          htmlBefore: '<i class="fas fa-file-invoice-dollar"></i>',
          controller: "NoteExtract",
          action: "List"
        },
        {
          title: "Transferências bancárias",
          to: "/financial/transfer-register",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-exchange-alt"></i>',
          controller: "TransferRegister",
          action: "List"
        },
        {
          title: "Transações",
          to: "/financial/transaction",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-exchange-alt"></i>',
          controller: 'Transaction',
          action: 'List'
        },
        {
          title: "Comissões dos parceiros",
          to: "/financial/partner-commissions",
          htmlBefore: '<i class="fas fa-hand-holding-usd"></i>',
          controller: "CheckingAccountPartner",
          action: "List"
        },
        {
          title: "Notas de serviço dos parceiros",
          to: "/financial/note-extract-partners",
          htmlBefore: '<i class="fas fa-file-invoice-dollar"></i>',
          controller: "NoteExtractPartner",
          action: "List"
        }
      ]
    },
    {
      title: "Financeiro",
      htmlBefore: '<i class="fas fa-dollar-sign"></i>',
      items: [
        
        {
          title: 'Contas Bancárias',
          to: '/financial/bank-accounts',
          htmlBefore: '<i class="fas fa-clipboard-list"></i>',
          controller: 'BankAccount',
          action: 'List'
        },
        {
          title: 'Fluxo de Caixa',
          to: '/financial/cash-flow',
          htmlBefore: '<i class="fas fa-wave-square"></i>',
          controller: 'CashFlow',
          action: 'List',
          dividerEnabled: true
        },
        {
          title: "Contas a Pagar",
          to: "/financial/accounts/payable",
          htmlBefore: '<i class="fas fa-calendar-day"></i>',
          controller: "AccountsPayable",
          action: "List"
        },
        {
          title: "Contas a Receber",
          to: "/financial/accounts/receivable",
          htmlBefore: '<i class="fas fa-calendar-day"></i>',
          controller: "AccountsReceivable",
          dividerEnabled: true,
          action: "List"
        },
        {
          title: "Fluxo de Caixa",
          to: "/financial/cash-flow",
          htmlBefore: '<i class="fas fa-wave-square"></i>',
          controller: "CashFlow",
          action: "List"
        }
      ]
    },
    {
      title: "Gestão de Riscos",
      htmlBefore: '<i class="fas fa-chalkboard-teacher"></i>',
      items: [
        // {
        //   title: "Dashboard Chargeback",
        //   to: "/fraud/chargeback-dashboard",
        //   htmlBefore: '<i class="fas fa-chart-line"></i>',
        //   controller: "Chargeback",
        //   action: "GetDashboard"
        // },
        {
          title: "Chargebacks",
          to: "/fraud/chargeback",
          htmlBefore: '<i class="fas fa-money-check-alt"></i>',
          controller: "Chargeback",
          action: "List"
        },
        {
          title: "Chargebacks Marketplace",
          to: "/fraud/chargebacks-marketplace-dashboard",
          htmlBefore: '<i class="fas fa-comment-dollar"></i>',
          controller: "Chargeback",
          action: "GetMarketplace"
        },
        // {
        //   title: "Emailage",
        //   to: "/fraud/emailage",
        //   htmlBefore: '<i class="fas fa-envelope-open-text"></i>',
        //   controller: "Emailage",
        //   action: "List"
        // },
        {
          title: "Transações suspeitas",
          to: "/fraud/suspectTransaction",
          htmlBefore: '<i class="fas fa-user-shield"></i>',
          controller: "SuspectTransaction",
          action: "List"
        },
        {
          title: "Blocklist",
          to: "/fraud/blockList",
          htmlBefore: '<i class="fas fa-user-alt-slash"></i>',
          controller: "BlockList",
          action: "List"
        },
        // {
        //   title: "ICC",
        //   to: "/fraud/merchantLimits",
        //   htmlBefore: '<i class="fas fa-list-alt"></i>',
        //   controller: "MerchantLimits",
        //   action: "List"
        // }
      ]
    },
    {
      title: "Relacionamento",
      htmlBefore: '<i class="fas fa-heart"></i>',
      items: [
        {
          title: "Clientes inativos - Atendimento",
          to: "/relationship/clients-not-transacting",
          htmlBefore: '<i class="fas fa-user-times"></i>',
          controller: "Merchant",
          action: "ListNotTransacting"
        },
        {
          title: "Clientes inativos - Comercial",
          to: "/relationship/clients-not-transacting-commercial",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-user-slash"></i>',
          controller: "Merchant",
          action: "ListNotTransacting"
        },
        {
          title: "Contratos dos clientes",
          to: "/relationship/merchant-contracts",
          htmlBefore: '<i class="fas fa-file-signature"></i>',
          controller: "Merchant",
          action: "ListMerchantContract"
        },
        {
          title: "Contratos dos parceiros",
          to: "/relationship/partner-contracts",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-file-contract"></i>',
          controller: "Partner",
          action: "ListPartnerContract"
        },
        {
          title: "Documentos dos clientes",
          to: "/relationship/merchant-docs",
          htmlBefore: '<i class="fas fa-file-alt"></i>',
          controller: "MerchantDoc",
          action: "List"
        },
        {
          title: "Documentos dos parceiros",
          to: "/relationship/partner-docs",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-id-card"></i>',
          controller: "PartnerDoc",
          action: "List"
        },
        // {
        //   title: "Reuniões com os prospects",
        //   to: "/relationship/prospect-trainings",
        //   htmlBefore: '<i class="fas fa-headset"></i>',
        //   controller: "Training",
        //   action: "List"
        // },
        // {
        //   title: "Reuniões com os clientes",
        //   to: "/relationship/merchant-trainings",
        //   htmlBefore: '<i class="fas fa-headset"></i>',
        //   controller: "Training",
        //   action: "List"
        // },
        // {
        //   title: "Reuniões com os parceiros",
        //   to: "/relationship/partner-trainings",
        //   htmlBefore: '<i class="fas fa-headset"></i>',
        //   controller: "Training",
        //   action: "List"
        // },
        // {
        //   title: "Melhorias sugeridas",
        //   to: "/relationship/training-improvements",
        //   dividerEnabled: true,
        //   htmlBefore: '<i class="fas fa-lightbulb"></i>',
        //   controller: "TrainingImprovement",
        //   action: "ListScore"
        // },
        {
          title: "Atendimento ao cliente",
          to: "/relationship/customer-service",
          htmlBefore: '<i class="fas fa-address-book"></i>',
          controller: "CustomerService",
          action: "List"
        },
        {
          title: "Atendimento ao parceiro",
          to: "/relationship/parceiro-atendimento",
          htmlBefore: '<i class="fas fa-address-book"></i>',
          controller: "ParceiroAtendimento",
          action: "List"
        },
        {
          title: "Desempenho dos clientes",
          to: "/relationship/merchant-metrics",
          htmlBefore: '<i class="fas fa-user-tag"></i>',
          controller: "ClientMaintenance",
          action: "List"
        },
        {
          title: 'Solicitações de alteração de parceiro',
          to: '/relationship/merchant-solicitations',
          htmlBefore: '<i class="fas fa-user-check"></i>',
          controller: "MerchantSolicitation",
          action: "List"
        },
        {
          title: "Solicitações de renovação",
          to: "/relationship/prospect-histories",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-check-double"></i>',
          controller: "ProspectHistory",
          action: "List"
        }
      ]
    },
    {
      title: "Administração",
      htmlBefore: '<i class="fas fa-list"></i>',
      items: [
        {
          title: "Usuários",
          to: "/administration/users",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-user-cog"></i>',
          controller: "UserInternal",
          action: "List"
        },
        // {
        //   title: "Chamados",
        //   to: "/administration/tickets",
        //   htmlBefore: '<i class="fas fa-ticket-alt"></i>',
        //   controller: "Ticket",
        //   dividerEnabled: true,
        //   action: "List"
        // },
        // {
        //   title: "Gerenciamento de mudanças",
        //   to: "/administration/change-management",
        //   htmlBefore: '<i class="fas fa-tasks"></i>',
        //   dividerEnabled: true,
        //   controller: "ChangeManagement",
        //   action: "List"
        // },
        // {
        //   title: "Calculadora de comissões",
        //   to: "/administration/calculator",
        //   dividerEnabled: true,
        //   htmlBefore: '<i class="fas fa-calculator"></i>',
        //   controller: "CommissionCompetence",
        //   action: "ListCalculator"
        // },
        {
          title: "Central de downloads",
          to: "/administration/downloads",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-arrow-down"></i>',
          controller: "Document",
          action: "List"
        },
        {
          title: "Gerador de assinaturas",
          to: "/administration/signatures",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-signature"></i>',
          isAuthorize: true
        },
        {
          title: "Templates de e-mail",
          to: "/administration/template-emails",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-envelope"></i>',
          controller: "TemplateEmail",
          action: "List"
        },
        {
          title: "E-mails em massa",
          to: "/administration/emailing",
          htmlBefore: '<i class="fas fa-mail-bulk"></i>',
          controller: "Emailing",
          action: "List"
        },
        // {
        //   title: "Limites",
        //   to: "/administration/limits",
        //   htmlBefore: '<i class="far fa-credit-card"></i>',
        //   controller: "Limits",
        //   action: "List"
        // }
        {
          title: "Operadores",
          to: "/administration/operators",
          htmlBefore: '<i class="fas fa-user-lock"></i>',
          controller: "Operator",
          action: "List"
        }
      ]
    },
    {
      title: "Cadastros internos",
      htmlBefore: '<i class="fas fa-cog"></i>',
      items: [
        {
          title: "Bandeiras",
          to: "/registrations/brand",
          htmlBefore: '<i class="fas fa-flag"></i>',
          controller: "Brand",
          action: "List"
        },
        {
          title: "Documentos",
          to: "/registrations/documents",
          htmlBefore: '<i class="fas fa-file-upload"></i>',
          controller: "Document",
          action: "List"
        },
        {
          title: "Tabela de comissões",
          to: "/registrations/commissions",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-coins"></i>',
          controller: "CommissionCompetence",
          action: "List"
        },
        {
          title: "Tabela de taxas",
          to: "/registrations/configuration-taxes",
          htmlBefore: '<i class="fas fa-percentage"></i>',
          controller: "ConfigurationTax",
          action: "List"
        },
        {
          label: "Tabela de tipo de composição de taxa",
          to: "/registrations/composition-fee-type",
          icon: "fas fas-solid fa-file-invoice-dollar",
          controller: "CompositionFeeType",
          action: "List"
        },
        {
          title: "Tabela de serviços",
          to: "/registrations/services",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-tags"></i>',
          controller: "PaymentMethod",
          action: "List"
        },
        {
          title: "Tabela de tipo de serviço",
          to: "/registrations/service-type",
          htmlBefore: '<i class="fas fa-inbox"></i>',
          controller: "ServiceType",
          action: "List"
        },
        {
          title: "Tabela de feriados bancários",
          to: "/registrations/holidays",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-calendar-check"></i>',
          controller: "Holiday",
          action: "List"
        },
        {
          title: "Tabela de documentos comerciais",
          to: "/registrations/merchant-doc-types",
          htmlBefore: '<i class="fas fa-file-alt"></i>',
          controller: "MerchantDocType",
          action: "List"
        },
        {
          title: "Tabela de documentos dos parceiros",
          to: "/registrations/partner-doc-types",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-file-invoice"></i>',
          controller: "PartnerDocType",
          action: "List"
        },
        { 
          title: "Tabela de países",
          to: "/registrations/countries",
          htmlBefore: '<i class="fas fa-globe-americas"></i>',
          controller: "Country",
          action: "List"
        },
        {
          title: "Tabela de estados",
          to: "/registrations/states",
          htmlBefore: '<i class="fas fa-map-marked-alt"></i>',
          controller: "State",
          action: "List"
        },
        {
          title: "Tabela de cidades",
          to: "/registrations/cities",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-map-marker-alt"></i>',
          controller: "City",
          action: "List"
        },
        {
          title: "Tabela de bancos",
          to: "/registrations/banks",
          htmlBefore: '<i class="fas fa-university"></i>',
          controller: "Bank",
          action: "List"
        },
        {
          title: "Tabela de agências",
          to: "/registrations/agencies",
          htmlBefore: '<i class="fas fa-building"></i>',
          controller: "Bank",
          action: "List"
        },
        {
          title: "Tabela de gateways",
          to: "/registrations/gateways",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-network-wired"></i>',
          controller: "Gateway",
          action: "List"
        },
        {
          title: "Tabela de tipos de espécies",
          to: "/registrations/specie-types",
          htmlBefore: '<i class="fas fa-file"></i>',
          controller: "SpecieType",
          dividerEnabled: true,
          action: "List"
        },
        {
          title: "Tipo de Registros",
          to: "/registrations/register-type",
          htmlBefore: '<i class="fas fa-file"></i>',
          controller: "Answer",
          action: "List"
        },
        {
          title: "Categorias do Atendimento ao Cliente",
          to: "/registrations/customer-service-category",
          htmlBefore: '<i class="fas fa-users-cog"></i>',
          controller: "CustomerServiceCategory",
          action: "List"
        },
        {
          title: "Categorias de Contato",
          to: "/registrations/contact-category",
          htmlBefore: '<i class="fa-solid fa-address-book"></i>',
          controller: "ContactCategory",
          action: "List"  
        },
        {
          title: "Categorias do Atendimento ao Parceiro",
          to: "/registrations/parceiro-atendimento-categoria",
          htmlBefore: '<i class="fas fa-users-cog"></i>',
          controller: "ParceiroAtendimentoCategoria",
          action: "List"
        },
        {
          title: "Categorias do Contas a Pagar",
          to: "/registrations/accounts-payable-category",
          htmlBefore: '<i class="fas fa-file-invoice-dollar"></i>',
          controller: "AccountsPayableCategory",
          action: "List"
        },
        {
          title: "Categorias do Contas a Receber",
          to: "/registrations/accounts-receivable-category",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-hand-holding-usd"></i>',
          controller: "AccountsReceivableCategory",
          action: "List"
        },
        {
          title: "Cadastro de Contas Bancárias",
          to: "/registrations/bank-account",
          htmlBefore: '<i class="fas fa-university"></i>',
          controller: "BankAccount",
          action: "List"
        },
        {
          title: "Categorias do Fornecedor",
          to: "/registrations/categorias-dos-fornecedores",
          htmlBefore: '<i class="fas fa-handshake"></i>',
          controller: "CategoriasDosFornecedores",
          action: "List"
        }
      ]
    },
    {
      title: "Configuração",
      htmlBefore: '<i class="fas fa-cog"></i>',
      items: [
        {
          title: "Áreas de negócio",
          to: "/settings/areas",
          htmlBefore: '<i class="fas fa-th-large"></i>',
          controller: "Area",
          action: "List"
        },
        {
          title: "Ações do controle de acesso",
          to: "/settings/access-actions",
          htmlBefore: '<i class="fas fa-bars"></i>',
          controller: "AccessAction",
          action: "List"
        },
        {
          title: "Controle de acesso",
          to: "/settings/access-controls",
          htmlBefore: '<i class="fas fa-user-lock"></i>',
          controller: "AccessControl",
          action: "List"
        },
        {
          title: "Permissões",
          to: "/settings/access-permissions",
          htmlBefore: '<i class="fas fa-key"></i>',
          controller: "UserProfileInternal",
          action: "List"
        }
      ]
    }
  ];
}



// WEBPACK FOOTER //
// ./src/data/header-nav-items.js